[
    {
        "title": "Dollar Lambda",
        "keywords": [
            "Python",
            "Argument Parser",
            "Parser Combinator"
        ],
        "startDate": "2021",
        "endDate": "2021",
        "description": "An alternative to argparse based on parser combinators and functional first principles.",
        "link": "https://dollar-lambda.readthedocs.io/en/latest/"
    },
    {
        "title": "Run Tracker",
        "keywords": [
            "Docker",
            "Hasura",
            "Postgres",
            "React",
            "Rescript"
        ],
        "startDate": "2021",
        "description": "Utilities for launching hyperparameter sweeps, logging metadata, and visualizing runs",
        "link": "https://github.com/run-tracker/"
    },
    {
        "title": "Python MuJoCo Wrapper",
        "keywords": [
            "MuJoCo",
            "Cython"
        ],
        "description": "Minimal Python bindings for the MuJoCo physics simulator.",
        "link": "https://github.com/mujoco/",
        "startDate": "2017"
    }
]